<template>
	<div
		class="d-flex justify-sm-center"
		:class="{ 'justify-space-around': !left, 'justify-lg-end': left }"
	>
		<span v-if="text" class="result-text">{{ text }}</span>
		<div v-if="single" class="result-digit single">
			<v-img height="30" :src="ballBalls[parseInt(value, 10)]" :alt="value" />
		</div>
		<div
			v-else
			class="result-digit"
			v-for="(digit, index) in value"
			:key="index"
		>
			<v-img width="30" contain :src="balls[parseInt(digit, 10)]" :alt="digit" />
		</div>
	</div>
</template>

<script>
import chunk from 'lodash/chunk.js';
import ball0 from 'assets/static/img/balls/fastpay/ball_0.png';
import ball1 from 'assets/static/img/balls/fastpay/ball_1.png';
import ball2 from 'assets/static/img/balls/fastpay/ball_2.png';
import ball3 from 'assets/static/img/balls/fastpay/ball_3.png';
import ball4 from 'assets/static/img/balls/fastpay/ball_4.png';
import ball5 from 'assets/static/img/balls/fastpay/ball_5.png';
import ball6 from 'assets/static/img/balls/fastpay/ball_6.png';
import ball7 from 'assets/static/img/balls/fastpay/ball_7.png';
import ball8 from 'assets/static/img/balls/fastpay/ball_8.png';
import ball9 from 'assets/static/img/balls/fastpay/ball_9.png';

export default {
	name: 'ResultDigitDisplay',
	props: {
		single: {
			type: Boolean,
			default: false
		},
		value: {
			type: String,
			required: true
		},
		group: {
			type: Number,
			default: null
		},
		text: {
			type: String,
			default: ''
		},
		left: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			balls: [
				ball0,
				ball1,
				ball2,
				ball3,
				ball4,
				ball5,
				ball6,
				ball7,
				ball8,
				ball9
			]
		};
	},
	methods: {
		chunk
	},
	computed: {
		computedValue() {
			if (this.group) {
				return chunk(this.value.split(''), this.group);
			} else {
				return this.value;
			}
		}
	}
};
</script>

<style scoped lang="scss">
@import 'css/variables';
.result-digit {
	display: flex;
	margin: 0 2px;

	&.single {
		height: 45px;
		width: 45px;
	}
}

.result-text {
	color: $darkblue;
	font-size: 25px;
	margin-right: 5px;
	width: 50px;
	margin-bottom: 10px;
}
</style>
